export const getBrandUuidWithMaxValue = (cards) => {
  if (cards.length === 0) {
    return null;
  }

  const maxValueBrand = cards.reduce((maxBrand, card) => {
    const value = Number(card.value.slice(1));
    if (!maxBrand || value > maxBrand.value) {
      return { brandUuid: card.brand_uuid || card.brandUuid, value: value };
    }
    return maxBrand;
  }, null);

  return maxValueBrand.brandUuid;
};
